import React from 'react';
import { getAuth, deleteUser } from 'firebase/auth';

const DeleteAccount = () => {
  const handleDeleteAccount = async () => {
    const auth = getAuth();
    const user = auth.currentUser;

    if (user) {
      try {
        await deleteUser(user);
        alert('Your account has been deleted successfully.');
        // Optionally, redirect the user to a different page
      } catch (error) {
        console.error('Error deleting account:', error.message);
        alert('Failed to delete account. Please try again.');
      }
    } else {
      alert('No user is currently signed in.');
    }
  };

  return (
    <div className="container p-4">
      <h1>Delete Account</h1>
      <p>Warning: This action is irreversible. Once you delete your account, all your data will be permanently removed.</p>
      <button onClick={handleDeleteAccount} style={{ color: 'white', backgroundColor: 'red', padding: '10px', border: 'none', borderRadius: '5px' }}>
        Delete My Account
      </button>
    </div>
  );
};

export default DeleteAccount;